import React from 'react'

import { InputUI } from '@fourthwall/components'

export const ProductInfoFields = () => (
  <div style={{ marginTop: -4 }}>
    <InputUI.Suggestion>
      In order for members to buy products you have to create members-only products under Products
      tab.
    </InputUI.Suggestion>
  </div>
)
